<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Param Details</h2>
  </div>
</div>

<div class="card">
  <form [formGroup]="addparamreport" (ngSubmit)="saveParamReport()">
      <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <input id="float-input"
                         type="text"
                         pInputText
                         formControlName="reportName"
                         autocomplete="off"
                         readonly="readonly"
                         class="textboxBorder-1" />
              </span>
          </div>
          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <input id="float-input1"
                         type="text"
                         appFormErrorMessages
                         pInputText
                         formControlName="reportparamshortnote"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-input1">
                      <span class="required-asteric"> * </span>Display Name
                  </label>
              </span>
          </div>
          <div class="field col-12 md:col-6">
              <span class="p-float-label">
                  <input id="float-input2"
                         type="text"
                         appFormErrorMessages
                         pInputText
                         formControlName="reportparamName"
                         autocomplete="off"
                         class="textboxBorder-1" />
                  <label for="float-input1">
                      <span class="required-asteric"> * </span>Report Param Name
                  </label>
              </span>
          </div>

          <div class="field-checkbox col-12 md:col-6 pt-3" style="align-items: end">
              <p-checkbox name="chkptflag"
                          value="Y"
                          label=""
                          binary="true"
                          formControlName="isrequired"
                          (click)="setAttributes()"></p-checkbox>
              <label for="chkptflag"> Is Global Attribute</label>
          </div>
          <p-splitter></p-splitter>
          <div class="field col-12 md:col-6 mb-0 mt-4" *ngIf="isglobalattribute">
              <h6>Global Attribute:</h6>
          </div>
          <div class="field col-12 md:col-6 pt-0" *ngIf="isglobalattribute">
              <p-dropdown [options]="globalattributelist"
                          formControlName="picklistValues"
                          dataKey="settingValue"
                          placeholder="-- Select --"
                          optionLabel="settingName"></p-dropdown>
          </div>
          <div class="field col-12 md:col-6 mb-0 mt-4" *ngIf="isdatatypeattribute">
              <h6>Data Type:</h6>
          </div>

          <div class="field col-12 md:col-6" *ngIf="isdatatypeattribute">
              <p-dropdown [options]="datatypes"
                          formControlName="datatype"
                          dataKey="value"
                          (onChange)="SetDatatypeControls()"
                          placeholder="-- Select --"
                          optionLabel="type"></p-dropdown>
          </div>
          <div class="col-12"> </div>
          <div class="field col-12 md:col-6" *ngIf="numberdatatype">
              <span class="p-float-label">
                  <input id="float-minn"
                         type="number"
                         pInputText
                         formControlName="minnumber"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-minn">Min Number</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="numberdatatype">
              <span class="p-float-label">
                  <input id="float-maxn"
                         type="number"
                         pInputText
                         formControlName="maxnumber"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-maxn"> Max Number</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="stringdatatype">
              <span class="p-float-label">
                  <input id="float-maxstr"
                         type="number"
                         pInputText
                         formControlName="maxstringlength"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-maxstr">Max Length</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="stringdatatype">
              <span class="p-float-label">
                  <input id="float-defstring"
                         type="text"
                         pInputText
                         formControlName="defaultvalue"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-defstring"> Default Value</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="datetimedatatype">
              <span class="p-float-label">
                  <input id="float-strtdt"
                         type="text"
                         pInputText
                         formControlName="startDateTime"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-strtdt">Begin DateTime</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="datetimedatatype">
              <span class="p-float-label">
                  <input id="float-endtdt"
                         type="text"
                         pInputText
                         formControlName="endDateTime"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-endtdt"> End DateTime</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="datedatatype">
              <span class="p-float-label">
                  <input id="float-begindte"
                         type="text"
                         pInputText
                         formControlName="mindate"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-begindte">Begin Date</label>
              </span>
          </div>

          <div class="field col-12 md:col-6" *ngIf="datedatatype">
              <span class="p-float-label">
                  <input id="float-endindte"
                         type="text"
                         pInputText
                         formControlName="maxdate"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-endindte"> End Date</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="timedatatype">
              <span class="p-float-label">
                  <input id="float-btime"
                         type="text"
                         pInputText
                         formControlName="startTime"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-btime">Begin Time</label>
              </span>
          </div>

          <div class="field col-12 md:col-6" *ngIf="timedatatype">
              <span class="p-float-label">
                  <input id="float-etime"
                         type="text"
                         pInputText
                         formControlName="endTime"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-etime">End Time</label>
              </span>
          </div>
          <div class="field col-12 md:col-6" *ngIf="currencydatatype">
              <span class="p-float-label">
                  <input id="float-mincurrr"
                         type="text"
                         pInputText
                         formControlName="minCurrency"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-mincurrr">Min Value</label>
              </span>
          </div>

          <div class="field col-12 md:col-6" *ngIf="currencydatatype">
              <span class="p-float-label">
                  <input id="float-maxcurr"
                         type="text"
                         pInputText
                         formControlName="maxCurrency"
                         autocomplete="off"
                         class="textboxBorder-1" />

                  <label for="float-maxcurr">Max Value</label>
              </span>
          </div>

          <div class="field col-4 md:col-1 mr-4">

              <button pButton
                      type="submit"
                      icon="pi pi-save"
                      label="Save"
                      class="ui-button-success"></button>
          </div>
          <div class="field col-1 md:col-1">
              <button pButton
                      type="button"
                      icon="pi pi-check"
                      label="Cancel"
                      class="p-button-plain GreyButton"
                      (click)="navigateToParamList()"></button>
          </div>
      </div>
  </form>
  <div
    class="col-12 p-messages p-messages-summary border-radius-5"
    *ngIf="ShowErrorSummary"
  >
    <span style="font-size: 14px">{{ errorValidationSummary }}</span>
  </div>
</div>
